import { render, staticRenderFns } from "./BadgeAvailabilityStock.vue?vue&type=template&id=181f0f94&scoped=true&"
import script from "./BadgeAvailabilityStock.vue?vue&type=script&lang=js&"
export * from "./BadgeAvailabilityStock.vue?vue&type=script&lang=js&"
import style0 from "./BadgeAvailabilityStock.vue?vue&type=style&index=0&id=181f0f94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181f0f94",
  null
  
)

export default component.exports